module.exports = __webpack_public_path__ + "img/42ne.c02d8930.svg";